module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('my-cell-header', {
    attrs: {
      "cellHeader": "投资者操作流程说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "账户注册流程",
      "is-link": ""
    },
    on: {
      "click": _vm.reigsterProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "特定对象确认流程",
      "is-link": ""
    },
    on: {
      "click": _vm.confirmProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约申请流程",
      "is-link": ""
    },
    on: {
      "click": _vm.appointmentProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约确认流程",
      "is-link": ""
    },
    on: {
      "click": _vm.appointmentconfirmProcess
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "合同签署流程说明",
      "is-link": ""
    },
    on: {
      "click": _vm.contractProcess
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "重要功能点说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "邀请码关联",
      "is-link": ""
    },
    on: {
      "click": _vm.invite
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "身份认证",
      "is-link": ""
    },
    on: {
      "click": _vm.confirm
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "风险承受能力测评",
      "is-link": ""
    },
    on: {
      "click": _vm.riskTest
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "预约申请",
      "is-link": ""
    },
    on: {
      "click": _vm.appointment
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "创建产品（产品买产品）",
      "is-link": ""
    },
    on: {
      "click": _vm.createProduct
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "双录",
      "is-link": ""
    },
    on: {
      "click": _vm.record
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "合同签署",
      "is-link": ""
    },
    on: {
      "click": _vm.contract
    }
  })], 1)], 1), _vm._v(" "), _c('my-cell-header', {
    attrs: {
      "cellHeader": "其他说明"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "订单状态说明",
      "is-link": ""
    },
    on: {
      "click": _vm.orderState
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "如何找回密码",
      "is-link": ""
    },
    on: {
      "click": _vm.findPwd
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69ab8516"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/guideList.vue
// module id = 1067
// module chunks = 1